import { render } from "./CustomerSatisfactionChart.vue?vue&type=template&id=10faa648&ts=true"
import script from "./CustomerSatisfactionChart.vue?vue&type=script&lang=ts"
export * from "./CustomerSatisfactionChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__